export default {
  baseStyle: {
    dialogContainer: {
      display: 'grid',
      gridTemplateColumns: '100%',
    },
    dialog: {
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
}
